<app-tab-form-modal [model$]="model$" [summaryItems]="summaryTopItems" [baseService]="purchaseOrderLineService">
  @if (purchaseOrderProcess === PurchaseOrderProcesses.purchasing) {
    <app-tab
      [model]="model$ | async"
      [templates]="[
        { header: orderLineHeader, template: lines },
        { header: salesOrderAllocationHeader, template: allocations },
        { header: purchaseOrderAllocationHeader, template: purchaseAllocations },
        { header: purchaseOrderReceiptsHeader, template: receipts },
        { header: commentsHeader, template: comments }
      ]"
    >
    </app-tab>
  } @else {
    <app-tab
      [model]="model$ | async"
      [templates]="[
        { header: orderLineHeader, template: lines },
        { header: salesOrderAllocationHeader, template: allocations },
        { header: purchaseOrderAllocationHeader, template: purchaseAllocations },
        { header: processingHeader, template: processing },
        { header: purchaseOrderReceiptsHeader, template: receipts },
        { header: commentsHeader, template: comments }
      ]"
    >
    </app-tab>
  }
</app-tab-form-modal>

<ng-template #lines>
  <app-purchase-order-line-details
    [purchaseOrderLineId]="purchaseOrderLineId"
    [purchaseOrderHeaderId]="purchaseOrderHeaderId"
    [supplierId]="supplierId"
    [productId]="productId"
  ></app-purchase-order-line-details>
</ng-template>

<ng-template #allocations>
  <app-purchase-order-line-sales-order-allocation
    [purchaseOrderLineId]="purchaseOrderLineId"
  ></app-purchase-order-line-sales-order-allocation>
</ng-template>

<ng-template #purchaseAllocations>
  <app-purchase-order-line-purchase-order-allocation
    [purchaseOrderLineId]="purchaseOrderLineId"
  ></app-purchase-order-line-purchase-order-allocation>
</ng-template>

<ng-template #processing>
  <app-purchase-order-line-requirements
    [purchaseOrderLineId]="purchaseOrderLineId"
  ></app-purchase-order-line-requirements>
</ng-template>

<ng-template #receipts>
  <app-purchase-order-line-receipts [purchaseOrderLineId]="purchaseOrderLineId"></app-purchase-order-line-receipts>
</ng-template>

<ng-template #comments>
  <app-purchase-order-comment [id]="purchaseOrderHeaderId" [commentStart]="commentStart"></app-purchase-order-comment>
</ng-template>
